export default [{
  name: 'afagu',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PF: {},
        PJ: {},
        TipoPessoa: null,
        PessoaDadosContato: {},
        PessoaEndereco: {},
      },
      Parcela: {},
      DadosIniciais: {},
      Fornecedor: {},
    },
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
  },
  getters: {
    model (state) {
      return state.model
    },
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PF: {},
          PJ: {},
          TipoPessoa: null,
          PessoaDadosContato: {},
          PessoaEndereco: {},
        },
        Parcela: {},
        DadosIniciais: {},
        Fornecedor: {},
      }
      commit('model', data)
    }
  },
}]
